import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'password'
})
export class PasswordPipe implements PipeTransform {
  transform(value: string): string {
    // Replace each character with an asterisk
    return value.replace(/./g, '•');
  }
}